import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { provideWebIdeLink } from 'ee_else_ce/pages/projects/shared/web_ide_link/provide_web_ide_link';
import { convertObjectPropsToCamelCase, parseBoolean } from '~/lib/utils/common_utils';
import { joinPaths, webIDEUrl } from '~/lib/utils/url_utility';
import WebIdeButton from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/vue_shared/components/web_ide_link.vue?vue3';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

export function initWebIdeLink({ el, router }) {
  if (!el) return;

  const { projectPath, ref, isBlob, webIdeUrl, showGitpodButton, gitpodEnabled, ...options } =
    convertObjectPropsToCamelCase(JSON.parse(el.dataset.options));
  const { cssClasses, defaultBranch } = el.dataset;

  // eslint-disable-next-line no-new
  new Vue({
    el,
    name: 'WebIdeButtonRoot',
    router,
    apolloProvider,
    provide: {
      projectPath,
      ...provideWebIdeLink(options),
    },
    render(h) {
      return h(WebIdeButton, {
        props: {
          isBlob,
          webIdeUrl: isBlob
            ? webIdeUrl
            : webIDEUrl(
                joinPaths(
                  '/',
                  projectPath,
                  'edit',
                  ref || defaultBranch,
                  '-',
                  this.$route?.params.path || '',
                  '/',
                ),
              ),
          projectPath,
          isGitpodEnabledForInstance: parseBoolean(showGitpodButton),
          isGitpodEnabledForUser: parseBoolean(gitpodEnabled),
          cssClasses,
          ...options,
          gitRef: ref,
        },
      });
    },
  });
}
